import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { BackendAPIService } from '../../core/backend-api.service';
import { SystemSettings } from '../../core/state/system-settings.state';
import { MediaDevice } from '../../modules/admin/user/models/user-device.model';

@Injectable({
    providedIn: 'root'
})
export class AdminAccountService {

    private adminUserServletUrl = 'servlets/accounts';

    constructor(private backendAPIService: BackendAPIService,
                private httpClient: HttpClient,
                private modalService: BsModalService
                // private userDevicesActions: UserDevicesActions
    ) {
    }

    getUserDevices(userId: number, httpHeaders?: HttpHeaders): Observable<Array<MediaDevice>> {
      // const headers = (httpHeaders !== undefined) ? httpHeaders : {'Content-Type': 'application/json'};

        return this.httpClient
            .get<{devices: Array<MediaDevice>}>(`${this.adminUserServletUrl}/device/${userId}/`, {observe: 'body'})
            .pipe(
                map((response: any) => response.devices)
            );
    }

    addUpdateUserDevice(devicesList: Array<MediaDevice>, userId: number): Observable<Array<MediaDevice>> {
        const body = {
            devicesList
        };

        return this.httpClient
            .put<Array<MediaDevice>>(`${this.adminUserServletUrl}/device/${userId}/`, body);
    }

    // TODO: do we still need userId as param?
    getSharedNumbers(userId: number, httpHeaders?: HttpHeaders): Observable<any> {
        // const headers = (httpHeaders !== undefined) ? httpHeaders : {'Content-Type': 'application/json'};

        return this.httpClient
            .get<{sharedNumbers: Array<any>}>(`${this.adminUserServletUrl}/device/sharednumbers/`, {observe: "body"})
            .pipe(
                map((response: any) => response.sharedNumbers)
            );
    }

    getSystemSettings(httpHeaders?: HttpHeaders): Observable<SystemSettings> {
        return this.httpClient
            .get<{settings: SystemSettings}>(`${this.adminUserServletUrl}/systemsettings/`, {observe: 'body'})
            .pipe(
                map((response: any) => response.settings)
            );
    }

    saveSystemSettings(settings: SystemSettings): Observable<SystemSettings> {
        const body = {
            settings
        };

        return this.httpClient
            .put<SystemSettings>(`${this.adminUserServletUrl}/systemsettings/`, body);
    }


}
